<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/4chap1#chap1">I. Politics and the Social Scene</a></p>
<p class="toc2"><a href="#/5chap2#chap2">A Letter to the Editors of <i>Politics</i></a></p>
<p class="toc2"><a href="#/6chap3#chap3">America the Beautiful: The Humanist in the Bathtub</a></p>
<p class="toc2"><a href="#/7chap4#chap4">Gandhi</a></p>
<p class="toc2"><a href="#/8chap5#chap5">Mlle. Gulliver en Amérique</a></p>
<p class="toc2"><a href="#/9chap6#chap6">No News, <i>or</i>, What Killed the Dog</a></p>
<p class="toc2"><a href="#/10chap7#chap7">The Contagion of Ideas</a></p>
<p class="toc2"><a href="#/11chap8#chap8">Artists in Uniform</a></p>
<p class="toc2"><a href="#/12chap9#chap9">My Confession</a></p>
<p class="toc2"><a href="#/13chap10#chap10">Letter from Portugal</a></p>
<p class="toc2"><a href="#/14chap11#chap11">Mister Rodriguez of Lisbon</a></p>
<p class="toc2"><a href="#/15chap12#chap12">Naming Names: The Arthur Miller Case</a></p>
<p class="toc2"><a href="#/16chap13#chap13">The <i>Vita Activa</i></a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/17chap14#chap14">II. Woman</a></p>
<p class="toc2"><a href="#/18chap15#chap15">Tyranny of the Orgasm</a></p>
<p class="toc2"><a href="#/19chap16#chap16">Up the Ladder from <i>Charm</i> to <i>Vogue</i></a></p>
<p class="toc2"><a href="#/20chap17#chap17">The Vassar Girl</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/21chap18#chap18">III. Literature and the Arts</a></p>
<p class="toc2"><a href="#/22chap19#chap19">Recalled to Life, <i>or</i>, Charles Dickens at the Bar</a></p>
<p class="toc2"><a href="#/23chap20#chap20">Settling the Colonel’s Hash</a></p>
<p class="toc2"><a href="#/24chap21#chap21">An Academy of Risk</a></p>
<p class="toc2"><a href="#/25chap22#chap22">The Fast in Fiction</a></p>
<p class="toc2"><a href="#/26chap23#chap23">Characters in Fiction</a></p>
<p class="toc2"><a href="#/27chap24#chap24">The American Realist Playwrights</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/28biography#biography">A Biography of Mary McCarthy</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-TOC.vue?744912ee